var _rect, _rect2, _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessionsIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#EBEBEB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7871 43.1876H33.1821L27.66 48.7097C27.1827 49.1869 26.3646 48.8461 26.3646 48.1719V43.18H24.8496C23.5922 43.18 22.5771 42.1649 22.5771 40.9075V27.2725C22.5771 26.015 23.5922 25 24.8496 25H43.7871C45.0446 25 46.0596 26.015 46.0596 27.2725V40.9075C46.0596 42.1649 45.0446 43.18 43.7871 43.18V43.1876Z",
    stroke: "#4242CE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3326 31.0674H55.1501C56.4075 31.0674 57.4225 32.0824 57.4225 33.3399V46.9749C57.4225 48.2323 56.4075 49.2474 55.1501 49.2474H52.1201V54.2393C52.1201 54.9134 51.302 55.2543 50.8247 54.7771L45.3026 49.2549H37.7276C36.4701 49.2549 35.4551 48.2399 35.4551 46.9824V45.4674",
    stroke: "#4242CE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3945 34.8545H31.667",
    stroke: "#4242CE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1826 34.8545H35.4551",
    stroke: "#4242CE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9697 34.8545H39.2422",
    stroke: "#4242CE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionsIcon);
export default __webpack_public_path__ + "static/media/sessions-icon.8cc8720add7f5b7f4946990d76eb4a97.svg";
export { ForwardRef as ReactComponent };